/* eslint-disable standard/no-callback-literal */
/* eslint-disable @typescript-eslint/no-explicit-any */
export const debounce = <T extends any[]>(callback: (...args: T) => void, wait: number) => {
  let timeout: NodeJS.Timeout | null = null
  return (...args: T) => {
    const next = () => callback(...args)
    if (timeout !== null) {
      clearTimeout(timeout)
    }
    timeout = setTimeout(next, wait)
  }
}
